// Raw API calls for expenses. Components go through hooks/useExpenses.js.
import { http } from "../http";

/** One year's entries, groups and recurring rules ({ year, today, expenses, groups, recurring }). */
export const getExpensesYear = (year) => http.get(`/expenses`, { params: { year } }).then((r) => r.data);

// Writes return { expense, group? } — group when the payload named a new one.
export const createExpense = (payload) => http.post(`/expenses`, payload).then((r) => r.data);
export const updateExpense = (id, payload) => http.put(`/expenses/${id}`, payload).then((r) => r.data);
export const removeExpense = (id) => http.delete(`/expenses/${id}`).then((r) => r.data);

export const createExpenseGroup = (payload) => http.post(`/expenses/groups`, payload).then((r) => r.data);
export const updateExpenseGroup = (id, payload) => http.put(`/expenses/groups/${id}`, payload).then((r) => r.data);
export const removeExpenseGroup = (id) => http.delete(`/expenses/groups/${id}`).then((r) => r.data);

export const createRecurringExpense = (payload) => http.post(`/expenses/recurring`, payload).then((r) => r.data);
export const updateRecurringExpense = (id, payload) =>
  http.put(`/expenses/recurring/${id}`, payload).then((r) => r.data);
export const removeRecurringExpense = (id) => http.delete(`/expenses/recurring/${id}`).then((r) => r.data);
